import { Search } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import { useGlobalSearch } from './use-global-search';

interface GlobalSearchTriggerProps {
  placeholder?: string;
  /** Max width of the trigger. Defaults to a comfortable size for toolbar use. */
  maxWidth?: number | string;
}

export function GlobalSearchTrigger({
  placeholder = 'Search jobs, customers & animals...',
  maxWidth = 420,
}: GlobalSearchTriggerProps) {
  const { openGlobalSearch } = useGlobalSearch();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={openGlobalSearch}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openGlobalSearch();
        }
      }}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        px: 1.5,
        py: 1,
        cursor: 'pointer',
        width: '100%',
        maxWidth,
        color: 'text.secondary',
        bgcolor: 'background.paper',
        transition: 'border-color 0.15s ease',
        '&:hover': {
          borderColor: 'text.primary',
        },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2,
        },
      }}
    >
      <Search fontSize="small" />
      <Typography variant="body2" noWrap>
        {placeholder}
      </Typography>
    </Stack>
  );
}
